<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="470">
    <v-card>
        <v-card-title>
             
          <p>TOTAL CREDIT AMOUNT: {{$money(payment.amount)}} </p>

        </v-card-title>
       
        <v-card-text>
            
             <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
              <div v-if="type=='Cash'">
                <v-text-field
                dense
                  :value="$money(sales_amount)"
                  label="SALES AMOUNT"
                  :disabled="true"
                ></v-text-field>
               
                <v-text-field
                dense
                 v-model="payment.service_charge"
                  label="SERVICE CHARGE"
                   :disabled="true"
                ></v-text-field>
                <v-text-field
                dense
                 :disabled="true"
                 v-model="payment.trucking_fee"
                  label="TRUCKING FEE"
                ></v-text-field>

                <v-text-field
                large
                 v-model="payment.cash_received"
                  label="CASH RECEIVED"
                  :rules="textRules"
                        required
                        filled 
                        outlined
                ></v-text-field>
                <p  v-if="type=='Cash'">CHANGE: {{$money(CHANGE)}} </p>
              </div>


              <div v-if="type=='Credit'">
                <v-text-field
                dense
                   v-model="paid_amount"
                  label="SALES AMOUNT"
                  @focus="paid_amount=''"
                ></v-text-field>
               
                <v-text-field
                dense
                 v-model="paid_service_charge"
                  label="SERVICE CHARGE"
                   @focus="paid_service_charge=''"
                ></v-text-field>
                <v-text-field
                dense
                 v-model="paid_trucking_fee"
                 @focus="paid_trucking_fee=''"
                  label="TRUCKING FEE"
                ></v-text-field>
                  <p class="title">TOTAL: {{$money(AMOUNTTOPAY)}} </p>
                    <span>Remaining Balance: {{$money($IsNum(payment.amount) - $IsNum(AMOUNTTOPAY))}}</span>
                    <span>Posted Payment: {{$money(POSTED_PAYMENT)}}</span>
              </div>


             </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" large  text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  large color="success"  depressed  @click="validate()">CONFIRM</v-btn>
        </v-card-actions>
    </v-card>
    <va-confirm :show="confirm" cancelbtn="No" okbtn="Complete" text="Complete Payment?" @DialogEvent="cEvent"/>
  </v-dialog>
</template>

<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
export default {
    mixins: [API_MIXINS],
  props: {
    show: {
        type: Boolean,
        default: false
    },
    payment: {
        type: Object,
        default: ()=>{ return {} }
    },
    sales_date: {
      type: String,
        default: ''
    },
    type: {
        type: String,
        default: 'Cash'
    }
  },
  data: () => ({
      valid: true,
      confirm: false,
      paid_amount: 0,
      paid_service_charge: 0,
      paid_trucking_fee: 0,
      sales_amount: 0,
      payments:[],
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
     ACCEPT() {
        if(this.type == 'Credit'){
            return true
        }
         if(this.$IsNum(this.payment.amount) <= this.$IsNum(this.payment.cash_received)) {
             return true
         } return false
     },
     CHANGE(){
         var change = this.$IsNum(this.payment.cash_received) - this.$IsNum(this.payment.amount)
         return change<0?0:change
     }, 
     AMOUNTTOPAY(){
        return this.$IsNum(this.paid_amount) + this.$IsNum(this.paid_service_charge) + this.$IsNum(this.paid_trucking_fee)
     },
     POSTED_PAYMENT(){
      let posted =  this.payments.reduce((res, item) =>res += this.$IsNum(item.amount), 0)
      return posted
    
     }
  },
  watch: {
    show(v) {
      if(v) {
          this.sales_amount = this.$IsNum(this.payment.amount) - this.$IsNum(this.payment.service_charge) - this.$IsNum(this.payment.trucking_fee) 
          this.getPayment()
      }
    }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
            if(this.ACCEPT) {
                //this.CompletePayment()
                this.confirm = true
            } else {
                this.VA_ALERT('error', "Insufficient amount received !")
            }
          
        }
      },
    emitToParent (action) {
      this.$emit('DialogEvent', action)
    },
    cEvent(data) {
      this.confirm = false
      if(data == 'ok') {
        this.PaySalesAmount()
      }
    },
    getPayment(){
      var param= {}
        param.start_date = this.sales_date
        param.account = this.payment.customer
        console.log(param)
        this.$http.post("transaction/get_payment", param).then(response => { 
            this.payments = response.data.data
        })
    },

    PaySalesAmount() {
         var param= {}
        param.type = 4
        param.amount = this.type=='Cash'?this.sales_amount.toString():this.paid_amount.toString()
        param.remarks = this.type=='Cash'?"Cash Sales Payment":"Credit Sales Payment"
        param.account = this.payment.customer
        param.account_type = 3
        param.sales_date = this.sales_date
        param.status = 'verified'
        if(this.type == "Credit") {
            this.payment.service_charge= this.paid_service_charge
            this.payment.trucking_fee = this.paid_trucking_fee
        }
        this.$http.post("transaction/add", param).then(response => {
             if(response.data.status == true) {
                  if(this.$IsNum(this.payment.service_charge) > 0) {
                    this.PaySC()
                  } else {
                    if(this.$IsNum(this.payment.trucking_fee) > 0) { 
                      this.PayTF()
                    }
                  }
                 
             } else {
                this.VA_ALERT('error', response.data.message)
                this.$emit('DialogEvent', 'close')
             }
             }).catch(e => {
           console.log(e.data)
         })
    },
    PaySC() {
         var param= {}
        param.type = 5
        param.amount = this.payment.service_charge.toString()
        param.remarks = "SC Payment"
        param.account = this.payment.customer
        param.account_type = 3
        param.sales_date = this.sales_date
        param.status = 'verified'
        this.$http.post("transaction/add", param).then(response => {
             if(response.data.status == true) {
                 if(this.$IsNum(this.payment.trucking_fee) > 0) { this.PayTF()}
             } else {
                this.VA_ALERT('error', response.data.message)
                 this.$emit('DialogEvent', 'close')
             }
              
             }).catch(e => {
           console.log(e.data)
         })
    },
    PayTF() {
         var param= {}
        param.type = 6
        param.amount = this.payment.trucking_fee.toString()
        param.remarks = "TF Payment"
        param.account = this.payment.customer
        param.sales_date = this.sales_date
        param.account_type = 3
        param.status = 'verified'
        this.$http.post("transaction/add", param).then(response => {
             if(response.data.status == true) {
                 this.VA_ALERT('success', "Payment Complete!")
                 this.$emit('DialogEvent', 'completed')
             } else {
                this.VA_ALERT('error', response.data.message)
                this.$emit('DialogEvent', 'close')
             }
              
             }).catch(e => {
           console.log(e.data)
         })
    }
  }
}
</script>
